import { useId } from '@atlaskit/ds-lib/use-id';
import { fg } from '@atlaskit/platform-feature-flags';

// Exposing a hook as a convenience for consumers, so they don't need to import
// from ds-lib themselves.
// TODO: rename this to `useSkipLinkId` when cleaning up fg('platform_dst_skip_link_id_remove_prefix')
/**
 * Returns a unique ID for use by layout elements and skip links.
 * Returns an ID for use by the layout element and skip links.
 */
export function usePrefixedUID(prefix: string = 'element') {
	const uniqueId = useId();

	if (fg('platform_dst_skip_link_id_remove_prefix')) {
		return uniqueId;
	}

	return `${prefix}-${uniqueId}`;
}

/**
 * Returns an ID for use by the layout element and skip links.
 *
 * If the consumer has already provided an ID, it will be used instead.
 * Otherwise, a unique ID will be returned.
 */
export function useLayoutId({
	providedId,
}: {
	/**
	 * The ID provided by the consumer. If provided, it will be used instead.
	 */
	providedId?: string;
} = {}): string {
	const uniqueId = usePrefixedUID();
	const id = providedId ? providedId : uniqueId;

	return id;
}
